<template>
  <div class="position-relative fancy-text-box">
    <div class="tools">
      <div class="tool">
        <a href="javascript:;" @click="toolClick('emoji')"><i class="fa fa-smile-o"></i></a>
      </div>
      <div class="tool">
        <a href="javascript:;" @click="toolClick('upload')"><i class="fa fa-upload"></i></a>
      </div>
      <div class="tool">
        <a href="javascript:;" @click="toolClick('send')"><i class="fa fa-send"></i></a>
      </div>
    </div>
    <quill 
      ref="quill-editor" 
      class="form-control"
      style="width: 100%; height: 75px; padding-right: 65px" 
      v-model="editorValue" 
      :mentionSearchFunction="mentionSearchFunction" 
      @keydown="keydownEvent" 
      :enterIsSend="true"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import Quill from './taskmanager/Quill.vue';

export default {
  components: { Quill },
  name: "fancy-textarea-box",
  props: {
    value: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      editorValue: ""
    }
  },
  mounted () {
    
  },
  methods: {
    keydownEvent(evt) {
      let mentionIsOn = document.querySelectorAll("#quill-mention-list").length > 0
      if(!evt.shiftKey && evt.key == "Enter" && !mentionIsOn){
        this.$emit("enterPressed", { content: this.$refs["quill-editor"].getAsPlainText() })
      } else {
        this.$emit("input", this.$refs["quill-editor"].getAsPlainText())
      }
    },
    clear() {
      this.$refs["quill-editor"].clear();
    },
    toolClick(tool) {
      this.$emit('toolClick', tool);
      if(tool == "emoji") {
        this.$refs["quill-editor"].openEmoji();
      }
    },
    async mentionSearchFunction(searchTerm, renderList, mentionChar) {
      let values = [];

      if (mentionChar === "@") {
        let results = await $.get(`${window.baseUrl}dashboard/tagselectorjson?page=1&search=${encodeURI(searchTerm)}`);
        values = results.results;
      }
      
      renderList(values, "");

    },
    focus() {
      this.$refs["quill-editor"].focus();
    },
    getAsPlainText() {
      return this.$refs["quill-editor"].getAsPlainText();
    }
  },
}
</script>

<style lang="scss">
.fancy-text-box .ql-editor {
  padding: 0 !important;
}

.fancy-text-box .tools {
  position: absolute;
  top: 5px;
  right: 10px;
  z-index: 1;

  .tool {
    padding: 0 3px;
    font-size: 18px;
    display: inline-block;
  }
} 
</style>